<template>
    <section id="games" class="games">
        <div id="virtual-sports" class="virtual-sports">
            <h3>{{$t('navigation.virtual_sports')}}</h3>
            <div class="container">
                <swiper :options="virtualSports.options">
                    <swiper-slide v-for="item in virtualSports.items" :key="item.webm">
                        <div class="item">
                            <div class="inner">
                                <div class="thumb">
                                    <avideo :srcs="[item.webm, item.mp4]" :poster="item.poster" />
                                </div>
                                <div class="title">{{$t(item.title)}}</div>
                            </div>
                        </div>
                    </swiper-slide>

                    <div class="swiper-pagination" slot="pagination"></div>
                    <div class="swiper-button-prev" slot="button-prev"></div>
                    <div class="swiper-button-next" slot="button-next"></div>
                </swiper>
            </div>
        </div>
        <div id="number-games" class="number-games">
            <h3>{{$t('navigation.number_games')}}</h3>
            <router-link :to="'/home#demo'" class="demo-banner">
                <div class="container">
                    <div class="pic"><limg class="gift1" src="/assets/gift1.png" alt="" /><limg class="gift2" src="/assets/gift2.png" alt="" /></div>
                    <div class="text">{{$t('games.number_games.info')}}</div>
                    <div class="pic"></div>
                </div>
            </router-link>
            <div class="games-inner white-bg">
                <div class="container">
                    <swiper :options="numberGames.options">
                        <swiper-slide v-for="item in numberGames.items" :key="item.webm">
                            <div class="item">
                                <div class="inner">
                                    <div class="thumb">
                                        <avideo :srcs="[item.webm,item.mp4]" :poster="item.poster" />
                                    </div>
                                    <div class="title">{{$t(item.title)}}</div>
                                </div>
                            </div>
                        </swiper-slide>

                        <div class="swiper-pagination" slot="pagination"></div>
                        <div class="swiper-button-prev" slot="button-prev"></div>
                        <div class="swiper-button-next" slot="button-next"></div>
                    </swiper>
                </div>
            </div>
        </div>
        <div id="jackpots" class="jackpots">
            <h3>{{$t('navigation.jackpots')}}</h3>
            <div class="container">
                <swiper :options="jackpots.options">
                    <swiper-slide v-for="item in jackpots.items" :key="item.webm">
                        <div class="item">
                            <div class="inner">
                                <div class="thumb">
                                    <avideo :srcs="[item.webm, item.mp4]" :poster="item.poster" />
                                </div>
                                <div class="title">{{$t(item.title)}}</div>
                            </div>
                        </div>
                    </swiper-slide>

                    <div class="swiper-pagination" slot="pagination"></div>
                    <div class="swiper-button-prev" slot="button-prev"></div>
                    <div class="swiper-button-next" slot="button-next"></div>
                </swiper>
            </div>
        </div>
        <div id="slots" class="slots">
            <h3>{{$t('navigation.slots')}}</h3>
            <div class="container">
                <swiper :options="slots.options">
                     <swiper-slide v-for="item in slots.items" :key="item.image">
                         <div class="item" v-if="item.video">
                            <silentbox-single class="inner icon-play" :src="item.video"><div class="thumb"><limg :src="item.image" alt="" /></div></silentbox-single>
                        </div>
                         <div class="item" v-else>
                            <div class="inner"><div class="thumb"><limg :src="item.image" alt="" /></div></div>
                        </div>
                    </swiper-slide>

                    <div class="swiper-pagination" slot="pagination"></div>
                    <div class="swiper-button-prev" slot="button-prev"></div>
                    <div class="swiper-button-next" slot="button-next"></div>
                </swiper>
            </div>
        </div>
        <demo />
    </section>
</template>

<script>
    import { swiper, swiperSlide } from 'vue-awesome-swiper'
    import Demo from './demo'

    export default {
        name: 'Games',
        components: { swiper, swiperSlide, Demo },
        data() {
            return {
                virtualSports: { 
                    items: [
                        { title: 'games.virtual_sports.hounds_6', webm: '/assets/games/greyhounds_6.webm', mp4: '/assets/games/greyhounds_6.mp4', poster: '/assets/games/greyhounds_6.jpg' },
                        { title: 'games.virtual_sports.hounds_8', webm: '/assets/games/greyhounds_8.webm', mp4: '/assets/games/greyhounds_8.mp4', poster: '/assets/games/greyhounds_8.png' },
                        { title: 'games.virtual_sports.horses_6', webm: '/assets/games/horses_6.webm', mp4: '/assets/games/horses_6.mp4', poster: '/assets/games/horses_6.png' },
                        { title: 'games.virtual_sports.horses_8', webm: '/assets/games/horses_8.webm', mp4: '/assets/games/horses_8.mp4', poster: '/assets/games/horses_8.png' },
                        { title: 'games.virtual_sports.penalty', webm: '/assets/games/penalty.webm', mp4: '/assets/games/penalty.mp4', poster: '/assets/games/penalty.png' },
                        { title: 'games.virtual_sports.virtual_football', webm: '/assets/games/virtual_football.webm', mp4: '/assets/games/virtual_football.mp4', poster: '/assets/games/virtual_football.png' }
                    ],
                    options: {
                        watchOverflow: true,
                        slidesPerView: 3,
                        slidesPerColumn: 2,
                        slidesPerGroup: 3,
                        pagination: {
                            el: '.swiper-pagination',
                            clickable: true
                        },
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev'
                        },
                        breakpoints: {
                            768: {
                                slidesPerView: 2,
                                slidesPerGroup: 2
                            }
                        }
                    }
                },
                numberGames: {
                    items: [
                        { title: 'games.number_games.bingo37', webm: '/assets/number-games/bingo_37.webm', mp4: '/assets/number-games/bingo_37.mp4', poster: '/assets/number-games/bingo_37.png' },
                        { title: 'games.number_games.fortune', webm: '/assets/number-games/fortune.webm', mp4: '/assets/number-games/fortune.mp4', poster: '/assets/number-games/fortune.png' },
                        { title: 'games.number_games.roulette2', webm: '/assets/number-games/roulette2.webm', mp4: '/assets/number-games/roulette2.mp4', poster: '/assets/number-games/roulette2.png' },
                        { title: 'games.number_games.fortune_shake', webm: '/assets/number-games/fortune_shake.webm', mp4: '/assets/number-games/fortune_shake.mp4', poster: '/assets/number-games/fortune_shake.png' },
                        { title: 'games.number_games.jx_keno', webm: '/assets/number-games/jxKeno.webm', mp4: '/assets/number-games/jxKeno.mp4', poster: '/assets/number-games/jxKeno.png' },
                        { title: 'games.number_games.keno2', webm: '/assets/number-games/keno2.webm', mp4: '/assets/number-games/keno2.mp4', poster: '/assets/number-games/keno2.png' },
                        { title: 'games.number_games.keno', webm: '/assets/number-games/keno.webm', mp4: '/assets/number-games/keno.mp4', poster: '/assets/number-games/keno.png' },
                        { title: 'games.number_games.keno_22', webm: '/assets/number-games/keno_22.webm', mp4: '/assets/number-games/keno_22.mp4', poster: '/assets/number-games/keno_22.png' },
                        { title: 'games.number_games.live_roulette', webm: '/assets/number-games/live_roulette.webm', mp4: '/assets/number-games/live_roulette.mp4', poster: '/assets/number-games/live_roulette.png' },
                        { title: 'games.number_games.mbk_keno', webm: '/assets/number-games/mbk_keno.webm', mp4: '/assets/number-games/mbk_keno.mp4', poster: '/assets/number-games/mbk_keno.png' },
                        { title: 'games.number_games.old_fortune', webm: '/assets/number-games/old_fortune.webm', mp4: '/assets/number-games/old_fortune.mp4', poster: '/assets/number-games/old_fortune.png' },
                        { title: 'games.number_games.wheel_of_fortune', webm: '/assets/number-games/wheel_of_fortune.webm', mp4: '/assets/number-games/wheel_of_fortune.mp4', poster: '/assets/number-games/wheel_of_fortune.png' },
                        { title: 'games.number_games.x_keno', webm: '/assets/number-games/xKeno.webm', mp4: '/assets/number-games/xKeno.mp4', poster: '/assets/number-games/xKeno.png' },
                        { title: 'games.number_games.x_keno_jp', webm: '/assets/number-games/xKenoJP.webm', mp4: '/assets/number-games/xKenoJP.mp4', poster: '/assets/number-games/xKenoJP.png' },
                        { title: 'games.number_games.mohkeno', webm: '/assets/number-games/mohkeno.webm', mp4: '/assets/number-games/mohkeno.mp4', poster: '/assets/number-games/mohkeno.jpg' },
                    ],
                    options: {
                        watchOverflow: true,
                        slidesPerView: 3,
                        slidesPerColumn: 2,
                        slidesPerGroup: 3,
                        pagination: {
                            el: '.swiper-pagination',
                            clickable: true
                        },
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev'
                        },
                        breakpoints: {
                            768: {
                                slidesPerView: 2,
                                slidesPerGroup: 2
                            }
                        }
                    }
                },
                jackpots: {
                    items: [
                        { title: 'games.jackpots.jackpot spark', webm: '/assets/jackpots/jacpot_spark.webm', mp4: '/assets/jackpots/jacpot_spark.mp4', poster: '/assets/jackpots/jacpot_spark.jpg' },
                        { title: 'games.jackpots.jackpot fire', webm: '/assets/jackpots/jackpot_fire.webm', mp4: '/assets/jackpots/jackpot_fire.mp4', poster: '/assets/jackpots/jackpot_fire.jpg' },
                        { title: 'games.jackpots.jackpot party', webm: '/assets/jackpots/jackpot_party.webm', mp4: '/assets/jackpots/jackpot_party.mp4', poster: '/assets/jackpots/jackpot_party.jpg' }
                    ],
                    options: {
                        watchOverflow: true,
                        slidesPerView: 3,
                        slidesPerColumn: 1,
                        slidesPerGroup: 3,
                        pagination: {
                            el: '.swiper-pagination',
                            clickable: true
                        },
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev'
                        },
                        breakpoints: {
                            768: {
                                slidesPerView: 2,                                
                                slidesPerGroup: 2
                            }
                        }
                    }
                },
                slots: {
                    items:[
                        { image: "/assets/slots/bananas_go_bahamas_v2.png", video: "https://www.youtube.com/watch?v=APl2v4ydeR4"},
                        { image: "/assets/slots/book_of_ra_deluxe_v2.png", video: "https://www.youtube.com/watch?v=oQJjrU22R3w"},
                        { image: "/assets/slots/attila_v2.png", video: ""},
                        { image: "/assets/slots/crazy_monkey_v2.png", video: "https://www.youtube.com/watch?v=uxTsafRS_PE"},
                        { image: "/assets/slots/dolphins_pearl_v2.png", video: "https://www.youtube.com/watch?v=FxAXYPqmdpY"},
                        { image: "/assets/slots/fruit_coctail_v2.png", video: "https://www.youtube.com/watch?v=TuYKtQ5lO0I"},
                        { image: "/assets/slots/havana_club_v2.png", video: "https://www.youtube.com/watch?v=ZUWKoYLwHKQ"},
                        { image: "/assets/slots/just_jewels_v2.png", video: "https://www.youtube.com/watch?v=cpkgezIl3AY"},
                        { image: "/assets/slots/lucky_hunter_v2.png", video: "https://www.youtube.com/watch?v=HA_Q89GkoCQ"},
                        { image: "/assets/slots/phoenixs_fruits_v2.png", video: "https://www.youtube.com/watch?v=6VG80gA4SBY"},
                        { image: "/assets/slots/resident_v2.png", video: "https://www.youtube.com/watch?v=nZym98jq87M"},
                        { image: "/assets/slots/sizzling_hot_deluxe_v2.png", video: "https://www.youtube.com/watch?v=ZA7vBeegAbk"},
                        { image: "/assets/slots/columbus_deluxe_v2.png", video: "https://www.youtube.com/watch?v=fiLNRFWTfVo"},
                        { image: "/assets/slots/always_hot_v2.png", video: ""},
                        { image: "/assets/slots/the_euro_game_v2.png", video: "https://www.youtube.com/watch?v=xGThR6QGbvE"},
                        { image: "/assets/slots/banana_splash_v2.png", video: ""},
                        { image: "/assets/slots/beetle_mania_deluxe_v2.png", video: ""},
                        { image: "/assets/slots/blood_suckers_v2.png", video: ""},
                        { image: "/assets/slots/book_of_ra_v2.png", video: ""},
                        { image: "/assets/slots/carribbean_holidays_v2.png", video: ""},
                        { image: "/assets/slots/cold_spell_v2.png", video: ""},
                        { image: "/assets/slots/columbus_v2.png", video: ""},
                        { image: "/assets/slots/diamond_dogs_v2.png", video: ""},
                        { image: "/assets/slots/dolphins_pearl_deluxe_v2.png", video: ""},
                        { image: "/assets/slots/dynasty_of_ming_v2.png", video: ""},
                        { image: "/assets/slots/emperors_china_v2.png", video: ""},
                        { image: "/assets/slots/explosive_cocktail_v2.png", video: ""},
                        { image: "/assets/slots/fortune_teller_v2.png", video: ""},
                        { image: "/assets/slots/gryphons_gold_deluxe_v2.png", video: ""},
                        { image: "/assets/slots/gryphons_gold_v2.png", video: ""},
                        { image: "/assets/slots/hat_trick_v2.png", video: ""},
                        { image: "/assets/slots/heart_of_princess_v2.png", video: ""},
                        { image: "/assets/slots/houdini_v2.png", video: ""},
                        { image: "/assets/slots/illusionist_v2.png", video: ""},
                        { image: "/assets/slots/james_cook_v2.png", video: ""},
                        { image: "/assets/slots/jewels_4_all_v2.png", video: ""},
                        { image: "/assets/slots/just_jewels_deluxe_v2.png", video: ""},
                        { image: "/assets/slots/king_of_cards_v2.png", video: ""},
                        { image: "/assets/slots/lemon_cherry_v2.png", video: ""},
                        { image: "/assets/slots/limoncello_v2.png", video: ""},
                        { image: "/assets/slots/lucky_ladys_charm_deluxe_v2.png", video: ""},
                        { image: "/assets/slots/lucky_ladys_charm_v2.png", video: ""},
                        { image: "/assets/slots/magic_luck_v2.png", video: ""},
                        { image: "/assets/slots/marco_polo_v2.png", video: ""},
                        { image: "/assets/slots/ocean_pearl_v2.png", video: ""},
                        { image: "/assets/slots/olivers_bar_v2.png", video: ""},
                        { image: "/assets/slots/pharaohs_goldII_v2.png", video: ""},
                        { image: "/assets/slots/pharaons_goldIII_v2.png", video: ""},
                        { image: "/assets/slots/queen_of_hearts_deluxe_v2.png", video: ""},
                        { image: "/assets/slots/royal_treasures_v2.png", video: ""},
                        { image: "/assets/slots/secret_forest_v2.png", video: ""},
                        { image: "/assets/slots/scroll_of_anubis_v2.png", video: ""},
                        { image: "/assets/slots/silver_fox_v2.png", video: ""},
                        { image: "/assets/slots/simsalabim_v2.png", video: ""},
                        { image: "/assets/slots/sizzling_hot_v2.png", video: ""},
                        { image: "/assets/slots/tales_of_krakow_v2.png", video: ""},
                        { image: "/assets/slots/the_money_game_v2.png", video: ""},
                        { image: "/assets/slots/threee_v2.png", video: ""},
                        { image: "/assets/slots/ultra_hot_deluxe_v2.png", video: ""},
                        { image: "/assets/slots/ultra_hot_v2.png", video: ""},
                        { image: "/assets/slots/voodoo_vibes_v2.png", video: ""},
                        { image: "/assets/slots/walking_death_v2.png", video: ""},
                        { image: "/assets/slots/wonderful_flute_v2.png", video: ""},
                        { image: "/assets/slots/xmas_luck_v2.png", video: ""},
                   
                    ],
                    options: {
                        watchOverflow: true,
                        slidesPerView: 5,
                        slidesPerColumn: 3,
                        slidesPerGroup: 5,
                        pagination: {
                            el: '.swiper-pagination',
                            clickable: true
                        },
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev'
                        },
                        breakpoints: {
                            768: {
                                slidesPerView: 4,
                                slidesPerGroup: 4
                            }
                        }
                    }
                }
            }
        },
        methods:{
            
        }
    }
</script>

<style lang="scss" scoped>
    .games {
        background: $white;
    }

    .games-inner {
        position: relative;
        overflow: hidden;
    }

    h2 {
        font-size: 6rem;
        font-weight: bold;
        text-align: center;
        text-transform: uppercase;
        margin: 0;
        padding: 4*$spacer $spacer;
        color: $black;
        background: $white;
    }

    h3 {
        font-size: 6rem;
        font-weight: 300;
        text-align: center;
        text-transform: uppercase;
        margin: 0;
        padding: 4*$spacer $spacer;
        color: $black;
    }

    .demo-banner {
        display: block;
        padding: $spacer;
        color: $white;
        background: $purple;
        transition: all 0.3s linear;

        &:hover {
            color: #fed12d;
        }

        .container {
            display: flex;
            justify-content: flex-start;
            align-items: center;
        }
        .pic {
            position: relative;
            flex: 1;

            .gift1 {
                position: relative;
                width: 40%;
                margin-bottom: -15%;
                left: 10%;
                animation: gift 2s ease-out infinite;
                transform-origin: center bottom;
            }

            .gift2 {
                position: absolute;
                width: 70%;
                right: 0;
                bottom: -125%;
                animation: gift 2s ease-out infinite;
                transform-origin: center bottom;
            }
        }

        .text {
            position: relative;
            font-size: 2.2rem;
            font-weight: normal;
            text-align: center;
            text-transform: uppercase;
            text-decoration: underline;
            margin: 0;
            flex: 1;
        }
    }

    .thumb {
        .avideo,
        .limage {
            position: absolute;
            width: 100%;
            height: 100%;
        }

        .limage {
            background: transparent;
        }
    }

    .virtual-sports,
    .jackpots {
        background: $grey;
        padding-bottom: 4*$spacer;
    }

    .virtual-sports,
    .number-games,
    .jackpots {
        padding-bottom: 4*$spacer;

        .thumb {
            position: relative;
            width: 100%;
            padding-bottom: 56%;
        }
    }

    .slots {
        .thumb {
            position: relative;
            width: 100%;
            padding-bottom: 66%;
        }
    }

    .items {
        display: flex;
        flex-wrap: wrap;
        padding: $spacer;
    }

    .swiper-container {
        margin-top: $spacer;
        margin-bottom: $spacer;
        margin-left: -$spacer;
        margin-right: -$spacer;
    }

    .item {
        display: block;
        padding: $spacer;

        .inner {
            position: relative;
            display: block;
            overflow: hidden;

            &.icon-play {
                &:before {
                    position: absolute;
                    display: block;
                    font-size: 2rem;
                    bottom: $spacer;
                    right: $spacer;
                    padding: 0.2em;
                    background: $grey;
                    color: $black;
                    border-radius: 100%;
                    box-shadow: 0 0 5px $black;
                    transition: all 0.3s linear;
                    z-index: 1;
                }
            }

            &:hover {
                &.icon-play {
                    &:before {
                         background: $primary;
                         color: $white;
                    }
                }
            }
        }

        .title {
            font-size: 18px;
            color: $white;
            text-transform: uppercase;
            text-align: center;
            margin: 0;
            padding: $spacer/2 $spacer;
            background: $grey-dark;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }
    }

    @media (max-width: ($tablet)-1) {
        .demo-banner {
            .text {
                text-align: left;
                flex: 2;

                & + .pic {
                    display: none;
                }
            }
        }
    }


    @keyframes gift {
        0% {
            transform: translateY(-10%);
        }

        50% {
            transform: translateY(10%) scaleX(1.2);
        }

        100% {
            transform: translateY(-10%);
        }
    }
</style>
